module.exports = __webpack_public_path__ + "static/media/cong-nghiep-thai-nguyen.7e4dc033.jpg";